import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { ApiService, UserService } from 'app/services';
import { Jsonp, RequestOptions, Http, Headers, ResponseContentType } from '@angular/http';
import { environment } from 'environments/environment';

@Injectable()
export class BanDoSoService {
  data: any = {};
  datanew: any = {};
  constructor(private router: Router, private api: ApiService, private http: Http, private user: UserService) {
  }
  APIURL = "api/ExcuteOracle";
  APIURL_FILE = "api/Files";
  APIURL_CMIS = "api/Cmis";

  uploadFile(desFolder: string, overWrite: string, fileList: FileList) {
    return this.api.uploadFile(this.APIURL_FILE, desFolder, overWrite, fileList);
  }
  uploadKmlReturnJson(desFolder: string, overWrite: string, file: File, filename) {
    let formData: FormData = new FormData();
    formData.append('uploadFile', file, file.name);
    formData.append('Desfolder', desFolder);
    formData.append('overWrite', overWrite);
    let headers = new Headers()
    let options = new RequestOptions({ headers: headers });
    return this.api.Excute("api/BanDoSo/KMLDecode", formData, options);
  }
  uploadExcelReturnJson(desFolder: string, overWrite: string, file: File) {
    let formData: FormData = new FormData();
    formData.append('uploadFile', file, file.name);
    formData.append('Desfolder', desFolder);
    formData.append('overWrite', overWrite);
    let headers = new Headers()
    let options = new RequestOptions({ headers: headers });
    return this.api.Excute("api/BanDoSo/UploadExcelReturnJson", formData, options);
  }
  Json2ExcelFile(json: string, filename: string, tablename: string, tableschema: string) {
    let formData: FormData = new FormData();
    formData.append('jsondata', json);
    formData.append('filename', filename);
    formData.append('tablename', tablename);
    formData.append('tableschema', tableschema);
    return this.api.downloadFile("api/BanDoSo/Json2ExcelFile", formData, filename);
  }
  saveMap(type, name, danhmucid, kinhdo, vido, mota) {
    var param = {
      config: JSON.stringify({ namesql: "PKG_BANDOSO.P_THEM_DULIEU_BANDOSO" }),
      para: JSON.stringify({
        v_type: type,
        v_danhmucid: danhmucid,
        v_name: name,
        v_kinhdo: kinhdo,
        v_vido: vido,
        v_mota: mota,
      })
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }
  saveMap1(move, str_move, str, str1, str2, str3, str4, str5, str6, str7, str8, str9, type, danhmucid) {
    var param = {
      config: JSON.stringify({ namesql: "PKG_BANDOSO.P_THEM_DULIEU" }),
      para: JSON.stringify({
        v_sua: move,
        v_ds_id_move: str_move,
        v_mataikhoan: this.user.getCurrentUser().mataikhoan,
        v_str: str,
        v_str1: str1,
        v_str2: str2,
        v_str3: str3,
        v_str4: str4,
        v_str5: str5,
        v_str6: str6,
        v_str7: str7,
        v_str8: str8,
        v_str9: str9,
        v_type: type,
        v_danhmucid : danhmucid
      })
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }
  loadInfo(danhmucid, imei) {
    var param = {
      config: JSON.stringify({ namesql: "PKG_BANDOSO.P_LAYDS_DULIEU_BANDOSO" }),
      para: JSON.stringify({
        v_danhmucid: danhmucid,
        v_imei: imei,
      })
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }
  getRFID(danhmucid) {
    var param = {
      config: JSON.stringify({ namesql: "PKG_BANDOSO.P_LAY_RFID" }),
      para: JSON.stringify({
        v_danhmucid: danhmucid
      })
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }
  getdanhmucidfromfile(tendanhmuc) {
    var param = {
      config: JSON.stringify({ namesql: "PKG_BANDOSO.P_LAYDS_RFID_FILE" }),
      para: JSON.stringify({
        v_tentba: tendanhmuc
      })
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }
  updateInfo(type, idcu, idmoi, kinhdo, vido, danhmucid) {
    var param = {
      config: JSON.stringify({ namesql: "PKG_BANDOSO.P_SUA_DULIEU_BANDOSO" }),
      para: JSON.stringify({
        v_mataikhoan: this.user.getCurrentUser().mataikhoan,
        v_danhmucid: danhmucid,
        v_type: type,
        v_idcu: idcu,
        v_idmoi: idmoi,
        v_kinhdo: kinhdo,
        v_vido: vido,
      })
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }
  downloadTempFile(){
    return this.api.downloadFile("api/BanDoSo/GetExcelTempFile","","Bản Đồ Số");
  }
  getMaCot(danhmucid) {
    var param = {
      config: JSON.stringify({ namesql: "PKG_BANDOSO.P_LAY_MACOT_DACO" }),
      para: JSON.stringify({
        v_danhmucid: danhmucid,
      })
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }
  getRFIDNew(danhmucid){
    var param = {
      config: JSON.stringify({ namesql: "PKG_BANDOSO.P_LAY_RFID_MOI" }),
      para: JSON.stringify({
        v_danhmucid: danhmucid,
      })
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }
  //Lấy dữ liệu
  get_REP_TB(strRFID : string){
    var param = {
      config: JSON.stringify({ namesql: "PKG_BANDOSO.P_GET_TOADOTB_REP" }),
      para: JSON.stringify({
        v_ListID: strRFID,
      })
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }
  //Thêm mới Rep ID
  add_new_REP(repid, macot, imei, kinhdo, vido, danhmucid){
    var param = {
      config: JSON.stringify({ namesql: "PKG_BANDOSO.P_LUU_REP_MOI" }),
      para: JSON.stringify({
        v_Repid: repid,
        v_Macot: macot,
        v_Imei: imei,
        v_Kinhdo: kinhdo, 
        v_Vido: vido,
        v_danhmucid: danhmucid,
        v_mataikhoan: this.user.getCurrentUser().mataikhoan
      })
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }
  //Lấy imei của repeater mới thêm
  get_new_imei(repid){
    var param = {
      config: JSON.stringify({ namesql: "PKG_BANDOSO.P_GET_IMEI_MOI" }),
      para: JSON.stringify({
        v_Repid: repid,
      })
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }
}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/tien-ich/ban-do-so/bandoso.service.ts